import {
  BehaviorAuthorizationType,
  useHasBehaviorAuthorization,
} from './useHasBehaviorAuthorization';

/**
 * Returns true when the current user can change household and entity
 * integration data links.
 */
export function useCanManageIntegrationData(): boolean {
  return useHasBehaviorAuthorization(
    BehaviorAuthorizationType.CAN_MANAGE_INTEGRATION_DATA,
    { detailed: false }
  );
}
